import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { GroupRoleDto } from 'projects/shared/src/lib/models/GroupRole';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { RoleDto } from 'projects/shared/src/lib/models/SquirrelRoles';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { ProjectRolesButtonRendererComponent } from './project-roles-button-renderer/project-roles-button-renderer.component';
import { ProjectGroupRoleDto, ProjectGroupRoleForCreationDto } from 'projects/shared/src/lib/models/projectgrouprole';
import { ProjectGroupRoleService } from 'projects/shared/src/lib/services/project-group-role.service';
import { AgGridProjectRolesSettings } from './AgGridProjectRolesSettings';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { AddProjectGrouproleDialogComponent } from './add-project-grouprole-dialog/add-project-grouprole-dialog.component';

@Component({
  selector: 'project-role',
  templateUrl: './project-role.component.html',
  styleUrls: ['./project-role.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectRoleComponent implements OnInit {
  @Input('project') project!:ProjectDto;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10;
  isLoading: boolean = false;

  projectGroupRoleForm!: FormGroup;

  roleDtos: RoleDto[] = [];
  roleDto!: RoleDto;

  groupRoleDtos: GroupRoleDto[] = [];
  groupRoleDto!: GroupRoleDto;

  projectGroupRoles: ProjectGroupRoleDto[] = [];

  showGrid: boolean = false;

  rowData: ProjectGroupRoleDto[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!: AgGridProjectRolesSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  _db!:string;
  _tenantName!:string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private projectGroupRoleService: ProjectGroupRoleService,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService) { }

  ngOnInit(): void {
    this.tenantService.projectId = this.project.id;
    // localStorage.setItem('project-id', this.project.id);
    //localStorage.setItem('tenant-db', this.project.tenantName);
    this._tenantName = this.tenantService.currentTenantName;


    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridProjectRolesSettings(this.translate);
    this.frameworkComponents = { buttonRenderer: ProjectRolesButtonRendererComponent };
    this.gridOptions = this.aggridSettings.agGridProjectRolesSettings;

    // this.oauthService.userData.subscribe({
    //   next: (data) => {
    //     if (typeof data != undefined && data != null) {
    //       let userRoles = data.role as Array<string>;
    //       userRoles.forEach((dbrole: string) => {
    //         if (dbrole === 'admin') {
    //          this._db = dbrole;
    //         }
    //       });
    //     }
    //   }
    // });

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'Role';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        if (this._db) {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLESERROR"]}`)
          // this.projectGroupRoleService.loadProjectGroupRoles(this.project.id, this.filter).subscribe({
          //   next: (projectGroupRoles) => {
          //     this.rowData = projectGroupRoles.slice(this.filter.startRow, this.filter.endRow);
          //     let lastRow = -1;

          //     if (this.rowData.length <= this.filter.endRow) {
          //       lastRow = this.rowData.length;
          //     }
          //     params.successCallback(this.rowData, lastRow);
          //     this.isLoadingResults = false;
          //     this.isRateLimitReached = false;
          //     this.resultsLength = this.rowData.length;

          //     this.gridApi.hideOverlay();

          //     //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDPROJECTGROUPROLES"]} `);
          //   },
          //   error: () => {
          //     this.isLoadingResults = false;
          //     this.isRateLimitReached = true;
          //     this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLESERROR"]}`)
          //   }
          // });
        }
        else {
          //let db:string = this.tenantService.currentTenantName;
          this.tenantService.getProjectGroupRoles(this.project.id, this._tenantName, this.filter).subscribe({
            next: (projectGroupRoles) => {
              console.log("------------------> PGR = ", projectGroupRoles)
              this.rowData = projectGroupRoles.slice(this.filter.startRow, this.filter.endRow);
              let lastRow = -1;

              if (this.rowData.length <= this.filter.endRow) {
                lastRow = this.rowData.length;
              }
              params.successCallback(this.rowData, lastRow);
              this.isLoadingResults = false;
              this.isRateLimitReached = false;
              this.resultsLength = this.rowData.length;

              this.gridApi.hideOverlay();

              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDPROJECTGROUPROLES"]} `);
            },
            error: () => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEDPROJECTGROUPROLESERROR"]}`)
            }
          });
        }
      }
    };
    //this.createProjectGroupRoleForm();
  }
 
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds);
  }

  get db() : string {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
             this._db = dbrole;
            }
          });
        }
      }
    });

    return this._db;
  }

  // createProjectGroupRoleForm() {
  //   this.projectGroupRoleForm = this.formBuilder.group({
  //     name: [null, Validators.required]
  //   })
  // }

  addProjectGroupRole() {
    const dialogRef = this.dialog.open(AddProjectGrouproleDialogComponent, { width: '800px', data: ProjectGroupRoleDto });
    dialogRef.afterClosed().subscribe((result: any) => { 

      if (result !== undefined) {
        let projectGroupRole = new ProjectGroupRoleDto;
        projectGroupRole.name = result.name;
        projectGroupRole.projectId = this.project.id;
        projectGroupRole.permissions = result.permissions;

        let db:string = this.tenantService.currentTenantName;
        this.tenantService.createProjectGroupRole(projectGroupRole, db).subscribe({
          next: (projectGroupRole: ProjectGroupRoleForCreationDto) => {
            let pgr = new ProjectGroupRoleDto;
            pgr.id = projectGroupRole.id;
            pgr.name = projectGroupRole.name;
            pgr.projectId = projectGroupRole.projectId
    
            this.rowData.splice(2, 0, pgr);
            this.rowData.push(pgr);
            this.gridApi.refreshInfiniteCache();
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${pgr.name} - ${this.translate.data["ADDPROJECTGROUPROLE"]} `);
          },
          error: () => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLEERROR"]} - ${projectGroupRole.name}`)
        })
          }
    },
    //error
  );

    // if (this.projectGroupRoleForm.valid) {
    //   let projectGroupRole = new ProjectGroupRoleForCreationDto
    //   projectGroupRole.name = this.projectGroupRoleForm.value.name;
    //   projectGroupRole.projectId = this.project.id;

    //   if (this._db) {
    //     this.createInMainDb(projectGroupRole);
    //   }
    //   else {
    //     this.createInTenantDb(projectGroupRole);
    //   }
    // }
  }

  cancel() {
    this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-projects']);
  }
}
